// Animated favicon driver.
// Chrome/Firefox often snapshot only the first frame of an SVG favicon, so we
// render frames to a canvas and swap the <link rel="icon"> href on a timer.
// Premium terminal look: black tile, gold prompt ">", blinking cursor.

export function startAnimatedFavicon() {
  const size = 64
  const canvas = document.createElement('canvas')
  canvas.width = size
  canvas.height = size
  const ctx = canvas.getContext('2d')

  // one <link> we keep updating
  let link = document.querySelector('link[rel~="icon"]')
  if (!link) {
    link = document.createElement('link')
    link.rel = 'icon'
    document.head.appendChild(link)
  }
  link.type = 'image/png'

  const GOLD = '#ffca63'
  let cursorOn = true

  function draw() {
    ctx.clearRect(0, 0, size, size)

    // black rounded tile
    const r = 13
    ctx.fillStyle = '#0a0a0a'
    ctx.beginPath()
    ctx.moveTo(r, 1)
    ctx.arcTo(size - 1, 1, size - 1, size - 1, r)
    ctx.arcTo(size - 1, size - 1, 1, size - 1, r)
    ctx.arcTo(1, size - 1, 1, 1, r)
    ctx.arcTo(1, 1, size - 1, 1, r)
    ctx.closePath()
    ctx.fill()

    // gold prompt ">"
    ctx.strokeStyle = GOLD
    ctx.lineWidth = 6.5
    ctx.lineCap = 'round'
    ctx.lineJoin = 'round'
    ctx.beginPath()
    ctx.moveTo(17, 22)
    ctx.lineTo(31, 32)
    ctx.lineTo(17, 42)
    ctx.stroke()

    // blinking cursor block
    if (cursorOn) {
      ctx.fillStyle = GOLD
      ctx.beginPath()
      ctx.roundRect(37, 37, 14, 6.5, 2)
      ctx.fill()
    }

    link.href = canvas.toDataURL('image/png')
  }

  draw()
  setInterval(() => {
    cursorOn = !cursorOn
    draw()
  }, 500)
}
